import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

export const gameSettingsAtom = atomWithStorage(
  'bw_gameSettings',
  { textSpeed: 4, soundEnabled: true, fontSize: 'medium' },
  undefined,
  { getOnInit: true },
)

// Beat IDs whose typewriter animation has already played this session.
// Plain atom — resets on page reload, which is the desired behavior.
export const animatedBeatIdsAtom = atom(new Set())

// The story the player is currently in (set when GamePlayer mounts, cleared on
// logout). Lets account pages (Profile/Settings) offer a one-click "Resume
// story" link back to /play/:storyId so opening Settings mid-play isn't a
// dead-end. Persisted so it survives the navigation away from the game route.
export const lastPlayedStoryAtom = atomWithStorage(
  'bw_lastPlayedStory',
  null, // { id, name }
  undefined,
  { getOnInit: true },
)